import { DndModalProps } from '../profile-dropdown.types';
import { AppModal } from '@components/form/Modal';
import { GhostButton } from '@components/form/button/ghost-button';
import { AppPrimaryButton } from '@components/form/button/app-primary-button';
import { AppDatePicker } from '@components/form/date/app-date-picker';
import { AppTimePicker } from '@components/form/date/app-time-picker';
import { AppInput } from '@components/form/input/app-input';
import { Button, Divider, Dropdown } from 'antd';
import { RiArrowDownSLine, RiEmotionLine } from 'react-icons/ri';
import { suggestedStatusMessages } from '../utils/dnd-constants';
import { disablePastdate, disablePastTime } from '../utils/disable-past-date-time';
import EmojiPicker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import type { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

export function DndModal({
  handleModalClose,
  open,
  handleSubmit,
  onSubmit,
  control,
  statusValue,
  handleDateChange,
  selectedDateTime,
  handleTimeChange,
  setMessage,
  emoji,
  handleSuggestedStatus,
  updatingUserStatus,
  timezoneDate,
  setEmoji,
}: DndModalProps) {
  const items: MenuProps['items'] = [
    {
      key: 'emoji',
      disabled: true,
      className: 'p-0!',
      label: (
        <EmojiPicker
          data={data}
          previewPosition="none"
          theme="light"
          onEmojiSelect={(selectedEmoji: { native: string }) => {
            if (selectedEmoji?.native) {
              setEmoji(selectedEmoji.native);
            }
          }}
        />
      ),
    },
  ];
  const { t } = useTranslation();
  return (
    <AppModal
      width={420}
      title={<AppModal.Title>{t('do_not_disturb_until')}</AppModal.Title>}
      onCancel={handleModalClose}
      destroyOnHidden
      open={open}
      footer={
        <div className="flex gap-4">
          <GhostButton onClick={handleModalClose} className="w-1/2">
            {capitalize(t('cancel'))}
          </GhostButton>
          <AppPrimaryButton
            loading={updatingUserStatus}
            onClick={handleSubmit(onSubmit)}
            key="submit"
            className="w-1/2"
          >
            {t('do_not_disturb')}
          </AppPrimaryButton>
        </div>
      }
    >
      <form>
        <div className="flex gap-4 mb-3">
          <AppDatePicker
            onChange={handleDateChange}
            value={selectedDateTime}
            name="date"
            required
            control={control}
            label={capitalize(t('date'))}
            showNow={false}
            disabledDate={(current) => disablePastdate(current, String(timezoneDate))}
          />
          <AppTimePicker
            onChange={handleTimeChange}
            value={selectedDateTime}
            name="time"
            required
            control={control}
            label={capitalize(t('time'))}
            showNow={false}
            disabledTime={disablePastTime(String(timezoneDate), String(selectedDateTime || timezoneDate))}
          />
        </div>
        <AppInput
          value={statusValue}
          placeholder={capitalize(t('status'))}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          prefix={
            <div>
              <Dropdown overlayStyle={{ padding: 0 }} menu={{ items }} trigger={['click']}>
                <span className="flex justify-center items-center! cursor-pointer!">
                  <span>{emoji ? emoji : <RiEmotionLine />}</span>
                  <RiArrowDownSLine />
                  <Divider type="vertical" />
                </span>
              </Dropdown>
            </div>
          }
          name="status"
          label={capitalize(t('status'))}
          control={control}
          required
        />
        <div className="mt-3 text-[16px]!">
          <h1 className="mb-1">{capitalize(t('suggested_status'))}</h1>
          <div>
            {suggestedStatusMessages.map((item) => (
              <Button
                key={item?.message}
                type="text"
                className="w-full text-[16px]! flex justify-start! rounded-md pl-0!"
                onClick={() => handleSuggestedStatus(item)}
              >
                <span className="pl-1">{item?.emoticon}</span>
                <p>
                  {item?.message} - {item?.time}
                </p>
              </Button>
            ))}
          </div>
        </div>
      </form>
    </AppModal>
  );
}
